// color design tokens export
export const tokensDark = {
  grey: {
    0: '#ffffff', // manually adjusted
    10: '#f6f6f6', // manually adjusted
    50: '#f0f0f0', // manually adjusted
    100: '#e0e0e0',
    200: '#c2c2c2',
    300: '#a3a3a3',
    400: '#858585',
    500: '#666666',
    600: '#525252',
    700: '#3d3d3d',
    800: '#292929',
    900: '#141414',
    1000: '#000000', // manually adjusted
  },
  primary: {
    100: '#ccdde8',
    200: '#60A86A',
    300: '#6699ba',
    400: '#3377a3',
    500: '#2E7D32',
    600: '#004470',
    700: '#1B5E20',
    800: '#002238',
    900: '#00111c',
  },
  // primary: { // original colours
  // 	// blue
  // 	50: "#e2f2fc",
  // 	100: "#baddf9",
  // 	200: "#8ec9f6",
  // 	300: "#60b3f1",
  // 	400: "#3ca3f0",
  // 	500: "#0e94ed",
  // 	600: "#0886e0",
  // 	700: "#00558C", // was 0074cd
  // 	800: "#0063bb",
  // 	900: "#00469c",
  // },
  secondary: {
    100: '#fcebe9',
    200: '#f5c4bd',
    300: '#ee9c91',
    400: '#e77565',
    500: '#00558C',
    600: '#b33e2e',
    700: '#862f22',
    800: '#5a1f17',
    900: '#2d100b',
  },
  // secondary: { // original colours
  // 	// orange
  // 	50: "#fbf3e1",
  // 	100: "#f6dfb3",
  // 	200: "#f1cb82",
  // 	300: "#ecb651",
  // 	400: "#e9a62d",
  // 	500: "#e79812",
  // 	600: "#e38d0d",
  // 	700: "#dd7e07",
  // 	800: "#d77003",
  // 	900: "#e04e39", // was cd5900
  // },
};

// function that reverses the color palette
// function reverseTokens(tokensDark) {
// 	const reversedTokens = {}
// 	Object.entries(tokensDark).forEach(([key, val]) => {
// 		const keys = Object.keys(val)
// 		const values = Object.values(val)
// 		const length = keys.length
// 		const reversedObj = {}
// 		for (let i = 0; i < length; i++) {
// 			reversedObj[keys[i]] = values[length - i - 1]
// 		}
// 		reversedTokens[key] = reversedObj
// 	})
// 	return reversedTokens
// }
// export const tokensLight = reverseTokens(tokensDark)

// mui theme settings
export const themeSettings = () => {
  return {
    palette: {
      primary: {
        ...tokensDark.primary,
        main: tokensDark.primary[500],
        light: tokensDark.primary[200],
      },
      secondary: {
        ...tokensDark.secondary,
        main: tokensDark.secondary[500],
        light: tokensDark.secondary[200],
      },
      neutral: {
        ...tokensDark.grey,
        main: tokensDark.grey[500],
        light: tokensDark.grey[100],
        white: tokensDark.grey[0],
      },
    },

    typography: {
      fontFamily: ['Inter', 'Roboto', 'Helvetica Neue', 'sans-serif'].join(','),
      fontSize: 14,
      h1: {
        fontFamily: ['Inter', 'Roboto', 'Helvetica Neue', 'sans-serif'].join(
          ','
        ),
        fontSize: 40,
      },
      h2: {
        fontFamily: ['Inter', 'Roboto', 'Helvetica Neue', 'sans-serif'].join(
          ','
        ),
        fontSize: 32,
      },
      h2Plain: {
        fontFamily: ['Inter', 'Roboto', 'Helvetica Neue', 'sans-serif'].join(
          ','
        ),
        fontSize: 28,
      },
      h3: {
        fontFamily: 'Helvetica Neue',
        fontSize: 24,
      },
      h4: {
        fontFamily: 'Helvetica Neue',
        fontSize: 20,
      },
      h5: {
        fontFamily: 'Helvetica Neue',
        fontSize: 16,
      },
      h6: {
        fontFamily: 'Helvetica Neue',
        fontSize: 14,
      },
      h7: {
        fontFamily: 'Helvetica Neue',
        fontSize: 8,
      },
    },
    components: {
      MuiDataGrid: {
        styleOverrides: {
          row: {
            '&.Mui-selected': {
              backgroundColor: tokensDark.primary[300],
              color: tokensDark.secondary.main,
              '&:hover': {
                backgroundColor: tokensDark.secondary[300],
              },
            },
          },
        },
      },
    },
  };
};
